import { render, staticRenderFns } from "./debt-collection.vue?vue&type=template&id=627ae0ce&scoped=true&"
import script from "./debt-collection.vue?vue&type=script&lang=ts&"
export * from "./debt-collection.vue?vue&type=script&lang=ts&"
import style0 from "./debt-collection.vue?vue&type=style&index=0&id=627ae0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ae0ce",
  null
  
)

export default component.exports